/**
 * ADHERENCE FORM
 * @todo: Ideally I'd like to nove this into the "protocols" directory
 */

import * as Forms from './forms';

(function( $ ) {
		'use strict';
		let isdaBody            = $( 'body' ),
		    isdaAdhForm         = $( '#protocols-adherence-letter-form' ),
		    isdaFormFirstRender = true;

		$( document ).ready( function() {
			//only run on protocol adh form
			if ( isdaBody.hasClass( 'single-protocol' ) && isdaAdhForm.length ) {
				//needed for functions that clone sets of fields
				var cloneId = 0;

				let isdaAdhForm      = $( '#protocols-adherence-letter-form' ),
				    eRegEntRadios    = $( '#e-regulated-entity-wrapper input:radio' ),
				    ePrimaryEntity   = $( '#e-select-primary-identifier' ),
				    adhPrimaryEntity = $( '.adh-select-primary' );

				//protocol 35: require lei fields if regulated entity
				eRegEntRadios.on( 'change', requireRegulatedEntity );

				//protocol 35: disable adh types based on regulated entity
				eRegEntRadios.on( 'change', enableAdhTypeAfterRegEnt );

				//protocol 35: disable adh types based on regulated entity in duplicate letter mode
				duplicate_letter_disable_adh_type();

				//protocol 35: enable secondary indentifier type if user chooses No LEI
				ePrimaryEntity.change( primaryIdentifierType );
				ePrimaryEntity.change( protocol35Limits );
				ePrimaryEntity.change( clearPrimaryIdentifierFields );

				//protocol 35: run on the indentifier radios
				$( '#e-secondary-indentifier-form-group input:radio' )
					.change( secondEntityIdentifiterType );

				//protocol 35: adherence type select w/o React
				$( '#adherence-type-35' ).change( protocol35AdherenceType );

				//protocol 35: adherence type entity identifier
				adhPrimaryEntity.change( protocol35AdhPrimaryIdentifier );
				adhPrimaryEntity.change( protocol35Limits );
				adhPrimaryEntity.change( protocol35AdherenceTypeClear );

				//protocol 35: adherence type entity "other" identifier
				$( '.adh-secondary-type input:radio' )
					.change( protocol35AdhSecondIdentifier );

				//show ajax loader gif when letter Preview button is clicked
				$( '#btn-preview-adh-letter' ).on( 'click', function() {
					$( this )
						.html( ' <img class="spinner" src="' + ISDA_Main.ajaxLoader + '">' );
				} );
				$( '.btn-exit-preview-adh-letter' ).on( 'click', function() {
					$( '#btn-preview-adh-letter' ).html( 'Preview' );
				} );

				//adds disabled attr to conditional fields - it was removed from markup for JS disabled browsers
				let disabledFieldIds = [
					'd-cb-3-val', 'd-cb-4-val', 'd-cb-5-val', 'd-cb-6-val',
					'd-cb-7-val', 'd-cb-8-val', 'd-cb-8-addr-val',
					'd-cb-8-attn-val', 'd-cb-9-val', 'd-cb-9-fax-val',
					'd-cb-9-attn-val', 'd-cb-10-val', 'd-cb-10-email-val',

					'a-cb-2-addr-val', 'a-cb-2-attn-val', 'a-cb-3-fax-val',
					'a-cb-3-attn-val', 'a-cb-4-email-val',
					'b-4-txt-val',
					'b-5-txt-val', 'b-6-txt-val', 'b-7-email-val',
					'b-7-addr-val', 'c-cb-3-city-val', 'c-cb-4-agent-val',

					'c-cb-6-email-val', 'c-cb-7-email-val', 'c-cb-8-email-val',

					'f-cb-1-val', 'f-cb-2-val', 'f-cb-3-val', 'f-cb-4-val', 'f-cb-5-val', 'f-cb-6-val', 'f-cb-7-val', 'f-cb-8-val', 'f-cb-9-val', 'f-cb-10-val', 'f-cb-11-val', 'f-cb-12-val',
					'f-cb-iteration2-1-val',
					'f-cb-iteration2-2-val',
					'f-cb-iteration2-3-val',
					'f-cb-iteration2-4-val',
					'f-cb-iteration2-5-val',
					'f-cb-iteration2-6-val',
					'f-cb-iteration2-7-val',
					'f-cb-iteration2-8-val',
					'f-cb-iteration2-9-val',
					'f-cb-iteration2-10-val',
					'f-cb-iteration2-11-val',
					'f-cb-iteration2-12-val',
					'f-cb-iteration2-13-val',
					'f-cb-iteration2-14-val',
					'f-cb-iteration2-15-val',
					'f-cb-13-val', 'f-cb-14-val', 'f-cb-15-val', 'f-cb-16-val', 'f-cb-17-val', 'f-cb-18-val', 'f-cb-19-val', 'f-cb-20-val', 'f-cb-21-val', 'f-cb-22-val', 'f-cb-23-val',
					'f-cb-iteration2-16-val',
					'f-cb-iteration2-17-val',
					'f-cb-iteration2-18-val',
					'f-cb-iteration2-19-val',
					'f-cb-iteration2-20-val',
					'f-cb-iteration2-21-val',
					'f-cb-iteration2-22-val',
					'f-cb-iteration2-23-val',
					'f-cb-iteration2-24-val',
					'f-cb-iteration2-25-val',
					'f-cb-iteration2-26-val',
					'f-cb-iteration2-27-val',
					'f-cb-iteration2-28-val',
					'f-cb-iteration2-29-val',
					'f-cb-iteration2-30-val',
				];

				disabled_conditional_fields_if_js_present( disabledFieldIds );
				//adds required attr to checkboxes that trigger conditionals if JS is present, removed from markup
				require_conditional_triggers_if_js_present();

				isdaAdhForm.validator().on( 'submit', revealSectionErrors );
				isdaAdhForm.validator().on( 'submit', detectDomDefault );

				if ( 'undefined' !== typeof adherenceTypeValues && 'undefined' !== typeof adherenceTypeValues.errors && 'undefined' !== typeof adherenceTypeValues.errors.funds && adherenceTypeValues.errors.funds.length && !isdaAdhForm.checkValidity() ) {
					$( 'button[name=submit-adherence-form]' ).click();
				}

				//clear contact details
				isdaBody.on( 'click', '.btn-form-clear', function() {
					clearFormFields( '#protocol-form-step-2' );
				} );

				isdaAdhForm.find( 'input:radio' ).change( function() {
					updateFormValidation( $( '#protocols-adherence-letter-form' ) );
				} );

				//run on all protocol app checkboxes
				isdaAdhForm.find( 'input:checkbox' ).change( function() {
					let thisCheckbox          = $( this ),
					    checkboxWrapper       = thisCheckbox.closest( '.checkbox' ),
					    checkboxWrapperParent = checkboxWrapper.parent( '.form-group' );

					protocolCheckboxConditionalFields( $( this ) );
					protocolOnlyOneRequiredCheckbox( $( this ) );
					selectAllJurisdictionsToggle( $(this) );

					//run on protocol app areas with conditional sections
					if ( checkboxWrapper.hasClass( 'checkbox-enables-section' ) ) {
						protocolCheckboxConditionalSections( thisCheckbox );
					}

					//run on protocol app area where secondary checkbox is required in addition to first
					if ( checkboxWrapper.hasClass( 'checkbox-requires-secondary' ) ) {
						protocolRequiresSecondCheckbox( thisCheckbox );
					}

					//run on protocol app D template in second conditional section of checkboxes
					if ( checkboxWrapperParent.attr( 'data-conditional-section' ) === 'd-cb-1-val' ) {
						protocolToggleDisableCheckboxes( thisCheckbox );
					}

					//populate point of contact checkbox
					if ( checkboxWrapper.attr( 'id' ) === 'contact-checkbox' ) {
						sameAsAbove();
					}

					updateFormValidation( $( '#protocols-adherence-letter-form' ) );
				} );

				//add new dtcc number
				$( '.btn-add-dtcc' ).on( 'click', function() {
					cloneId++;
					addFormGroup( cloneId, 'dtcc-form-group-wrapper' );
				} );

				//add new signature
				$( '.btn-add-signature' ).on( 'click', function() {
					cloneId++;
					addFormGroup( cloneId, 'signatory-form-group-wrapper' );
					$( '.single-authorized-signatory .conditional-required input' )
						.keyup( requireAuthSigClones );
				} );
				$( '.single-authorized-signatory .conditional-required input' )
					.keyup( requireAuthSigClones );
				//remove dtcc number/authorized signature clones
				isdaBody.on( 'click', '#signatory-form-group-wrapper .btn-remove-repeatable, #dtcc-form-group-wrapper .btn-remove-repeatable', function() {
					removeThisClone( $( this ) );
				} );

				$( '.btn-protocol-adherence-back' )
					.click( previousCollapsibleBtn );
				$( '.btn-protocol-adherence-next' )
					.click( nextCollapsibleAppBtn );

				$( '#selected-master' ).on( 'change', function() {
					enableReferenceID( $( this ) );
				} );
			}
		} ); // doc ready

		/**
		 * Protocol 35: Disable adherence types in duplicate letter depending on Regulated Entity
		 */
		function duplicate_letter_disable_adh_type() {
			let checkDuplicateValue = $( '#adherence-type-35' )
				.attr( 'data-reg-entity' );

			if ( checkDuplicateValue === '1' ) {
				disabledOtherAdherenceTypes( 'disable' );
				triggerSingleEntityType();
			} else {
				disabledOtherAdherenceTypes( 'enable' );
			}
		}

		/**
		 * Protocol 35: Require Elections fields if regulated entity is set to Yes
		 */
		function requireRegulatedEntity() {
			let regEntity = $( this ), orgName = $( '#e-org-name-val' ),
			    idTypeOne                      = $( '#e-select-primary-identifier' ),
			    identifier                     = $( '#e-identifier-val' ),
			    reqAsterisks                   = $( '.toggle-asterisk' ),
			    stepFive                       = $( '#protocol-form-step-5' ),
			    leiCheckbox                    = $( '#lei-warning-election' );

			if ( regEntity.val() === '1' ) {
				orgName.attr( 'required', 'required' );
				idTypeOne.attr( 'required', 'required' );
				identifier.attr( 'required', 'required' );
				leiCheckbox.attr( 'required', 'required' );
				reqAsterisks.addClass( 'visible' );

				disabledOtherAdherenceTypes( 'disable' );
				triggerSingleEntityType();
			} else {
				//remove required attrs
				orgName.removeAttr( 'required', 'required' );
				idTypeOne.removeAttr( 'required', 'required' );
				identifier.removeAttr( 'required', 'required' );
				leiCheckbox.removeAttr( 'required', 'required' );
				reqAsterisks.removeClass( 'visible' );

				disabledOtherAdherenceTypes( 'enable' );
			}
		}

		/**
		 * Protocol 35: Remove disabled adherence type if regulated entity is answered
		 */
		function enableAdhTypeAfterRegEnt() {
			//			$( '#adherence-type-35-mess' ).hide();
			//			$( '#adherence-type-35' ).removeAttr( 'disabled', 'disabled' );
		}

		/**
		 * Protocol 35: Trigger click on Single Entity Type
		 */
		function triggerSingleEntityType() {
			let adhType = $( '#adherence-type-35' );

			if ( adhType.val() !== '0' && adhType.val() !== '' ) {
				adhType.val( '0' ).trigger( 'change' );
			}
		}

		/**
		 * Protocol 35: Disable types 1-3 if Regulated Entity is set to yes
		 * @param action
		 */
		function disabledOtherAdherenceTypes( action ) {
			let adhType = $( '#adherence-type-35' ).children( 'option' );

			adhType.each( function() {
				let option = $( this ), optionVal = option.val();

				if ( optionVal === '1' || optionVal === '2' || optionVal === '3' ) {
					if ( action === 'disable' ) {
						option.attr( 'disabled', 'disabled' );
					} else {
						option.removeAttr( 'disabled', 'disabled' );
					}
				}
			} );
		}

		/**
		 * Protocol 35: Show additional type fields if user does not have LEI (Elections)
		 */
		function primaryIdentifierType() {
			let identifier         = $( this ),
			    conditionalSection = $( '#e-secondary-indentifier-form-group' ),
			    conditionalFields  = conditionalSection.find( 'input:radio' );

			if ( identifier.val() === 'lei' || identifier.val() === '' ) {
				conditionalSection.addClass( 'hidden' );
				conditionalFields.removeAttr( 'required', 'required' );
			} else {
				conditionalSection.removeClass( 'hidden' );
				conditionalFields.attr( 'required', 'required' );
			}
		}

		/**
		 * Protocol 35: Show "other" text field if that type is selected in Elections
		 */
		function secondEntityIdentifiterType() {
			let radio = $( this ), radioVal = radio.val(),
			    conditionalField            = $( '#e-identifier-other-val' ),
			    conditionalWrapper          = conditionalField.closest( '.conditional-form-group' );

			if ( radioVal === 'other' ) {
				conditionalWrapper.removeClass( 'hidden' );
				conditionalField.attr( 'required', 'required' );
			} else {
				conditionalField.val( '' );
				conditionalWrapper.addClass( 'hidden' );
				conditionalField.removeAttr( 'required', 'required' );
				//clear other
				conditionalField.val( '' );
			}
		}

		/**
		 * Protocol 35: Adherence Type Selection
		 */
		function protocol35AdherenceType() {
			let typeVal            = $( this ).val(),
			    typeFields         = $( '#adh-type-fields-' + typeVal ),
			    reqOrg             = typeFields.find( '#adh-org-name-val' ),
			    reqLei             = typeFields.find( '#adh-select-primary-identifier' ),
			    reqIdentifier      = typeFields.find( '#adh-identifier-val' ),
			    otherTypeFields    = typeFields.siblings( '.adh-type-35-fields' ),
			    otherReqOrg        = otherTypeFields.find( '#adh-org-name-val' ),
			    otherReqLei        = otherTypeFields.find( '#adh-select-primary-identifier' ),
			    otherReqIdentifier = otherTypeFields.find( '#adh-identifier-val' ),
			    otherTypeRadios    = otherTypeFields.find( '.radio input' ),
			    identifierCheckbox = $( '#lei-warning-wrap-type' );

			//require fields only when they're visible
			typeFields.removeClass( 'hidden' );
			identifierCheckbox.removeClass( 'hidden' );
			reqOrg.attr( 'required', 'required' );
			reqLei.attr( 'required', 'required' );
			reqIdentifier.attr( 'required', 'required' );

			otherTypeFields.addClass( 'hidden' );
			otherReqOrg.removeAttr( 'required', 'required' );
			otherReqLei.removeAttr( 'required', 'required' );
			otherReqIdentifier.removeAttr( 'required', 'required' );
			otherTypeRadios.removeAttr( 'required', 'required' );

			//clear fields as well
			otherReqOrg.val( '' );
			otherReqLei.val( '' );
			otherReqIdentifier.val( '' );
			otherTypeRadios.prop( 'checked', false );
		}

		/**
		 * Clear lei/non-lei related fields when LEI dropdown is toggled
		 */
		function protocol35AdherenceTypeClear() {
			let typeVal       = $( '#adherence-type-35' ).val(),
			    typeFields    = $( '#adh-type-fields-' + typeVal ),
			    reqIdentifier = typeFields.find( '#adh-identifier-val' ),
			    regTypeRadios = typeFields.find( '.radio input' ),
			    reqTypeOther  = typeFields.find( '#adh-identifier-other-val' );

			reqIdentifier.val( '' );
			reqTypeOther.val( '' );
			reqTypeOther.parent().addClass( 'hidden' );
			regTypeRadios.prop( 'checked', false );
		}

		/**
		 * Protocol 35: Require addt fields if user does not have LEI in adh type
		 */
		function protocol35AdhPrimaryIdentifier() {
			let identifier         = $( this ),
			    getAttrKey         = identifier.attr( 'data-enable-secondary' ),
			    conditionalSection = $( '#adh-secondary-entity-' + getAttrKey ),
			    conditionalFields  = conditionalSection.find( 'input:radio' );

			if ( identifier.val() === 'lei' ) {
				conditionalSection.addClass( 'hidden' );
				conditionalFields.removeAttr( 'required', 'required' );
			} else {
				conditionalSection.removeClass( 'hidden' );
				conditionalFields.attr( 'required', 'required' );
			}
		}

		/**
		 * Protocol 35: Alter max/min lengths on identifier depending on whether it's LEI
		 * Also add pattern to prevent spaces on LEI
		 * (Adherence Type && Comp E)
		 */
		function protocol35Limits() {
			let self = $( this ), leiFieldId = self.attr( 'id' ),
			    leiVal                       = self.val(),
			    visibleAdhFields             = $( '.adh-type-35-fields:not(.hidden)' ),
			    identifierField              = '';

			if ( leiFieldId === 'adh-select-primary-identifier' ) {
				identifierField = visibleAdhFields.find( '#adh-identifier-val' );
			} else if ( leiFieldId === 'e-select-primary-identifier' ) {
				identifierField = $( '#e-identifier-val' );
			}

			if ( !typeof identifierField ) {
				return;
			}

			let regexLei    = '[a-zA-Z0-9]+',
			    regexNonLei = '^[\u0021\u0023-\u007E\u00A1-\u00FF\u20AC\u2013\u2014\u2122\\s.]+';

			if ( leiVal === 'lei' ) {
				identifierField.attr( 'data-minlength', '20' );
				identifierField.attr( 'maxlength', '20' );
				identifierField.removeAttr( 'pattern' );
				identifierField.attr( 'pattern', regexLei );
				identifierField.attr( 'data-pattern-error', 'Please match the requested format. Spaces and special characters are not allowed in LEI Identifiers.' );
			} else {
				identifierField.attr( 'data-minlength', '3' );
				identifierField.attr( 'maxlength', '40' );
				identifierField.removeAttr( 'pattern' );
				identifierField.attr( 'pattern', regexNonLei );
				identifierField.attr( 'data-pattern-error', 'Non-Latin characters are not allowed.' );
			}
		}

		/**
		 * Protocol 35: Clear Lei/Non-Lei related fields every time type is changed
		 */
		function clearPrimaryIdentifierFields() {
			let otherField = $( '#e-identifier-other-val' );

			$( '#e-secondary-indentifier-form-group input:radio' )
				.prop( 'checked', false );
			$( '#e-identifier-val' ).val( '' );
			otherField.val( '' );
			otherField.parent().addClass( 'hidden' );
		}

		/**
		 * Protocol 35: Show "other" text field if user chooses that type in adh type
		 */
		function protocol35AdhSecondIdentifier() {
			let radio = $( this ), radioVal = radio.val(),
			    radioAttr                   = radio.attr( 'data-enable-secondary-other' ),
			    conditionalWrapper          = $( '#adh-secondary-other-' + radioAttr ),
			    conditionalField            = conditionalWrapper.find( '.form-control' );

			if ( radioVal === 'other' ) {
				conditionalWrapper.removeClass( 'hidden' );
				conditionalField.attr( 'required', 'required' );
			} else {
				conditionalWrapper.addClass( 'hidden' );
				conditionalField.removeAttr( 'required', 'required' );
				//clear other
				conditionalField.val( '' );
			}
		}

		/**
		 * Requires fields in authorized signatory only if fields are filled in
		 * Based on class 'conditional-required' on .form-group
		 * In place only on the protocol 35 form
		 */
		function requireAuthSigClones() {
			var $fieldSelector = $( '.single-authorized-signatory .conditional-required .form-control' ),
			    $emptyFields   = $fieldSelector.filter( function() {
				    return $.trim( this.value ) === '';
			    } ), addNewBtn = $( '.btn-add-signature' );

			if ( $emptyFields.length < 3 ) {
				$emptyFields.attr( 'required', 'required' );
				addNewBtn.removeAttr( 'disabled', 'disabled' )
				         .removeClass( 'disabled' );
				isdaAdhForm.validator( 'update' );
			} else {
				$emptyFields.removeAttr( 'required', 'required' );
				addNewBtn.attr( 'disabled', 'disabled' ).addClass( 'disabled' );
				isdaAdhForm.validator( 'update' );
				isdaAdhForm.validator( 'validate' );
				$emptyFields.closest( '.form-step' )
				            .removeClass( 'section-has-error' );
			}
		}

		function require_conditional_triggers_if_js_present() {
			let requiredFieldIds = [
				'd-cb-1-val', 'd-cb-2-val', 'a-cb-1-val', 'a-cb-2-val',
				'a-cb-3-val', 'a-cb-4-val'
			];

			$.each( requiredFieldIds, function( index, value ) {
				let field = $( '#' + value ),
				    fieldFormGroup = field.closest('.form-group');

				//.form-group-require-none should only apply to Component A
				if ( !field.hasClass( 'edit-mode-not-required' ) && !fieldFormGroup.hasClass( 'form-group-require-none' ) ) {
					field.attr( 'required', 'required' );
				}
			} );
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * @param fieldList
		 */
		function disabled_conditional_fields_if_js_present( fieldList ) {
			//Will only disabled fields when not in "duplicate letter" mode
			if ( window.location.search.indexOf( 'duplicate=' ) < 1 ) {
				$.each( fieldList, function( index, value ) {
					let field        = $( '#' + value ),
					    condWrapperD = field.closest( '.conditional-section' );
					//only disable fields when not in "edit letter" mode
					if ( !field.hasClass( 'edit-mode-remove-disabled' ) && !condWrapperD.hasClass( 'enable-conditional-section' ) ) {
						field.attr( 'disabled', 'disabled' );
					}
				} );
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * @summary Previous button in membership app
		 *
		 * Opens next section by triggering a click on expand/collapse btn
		 * Closes any other open sections
		 */
		function previousCollapsibleBtn() {
			var thisFormStep = $( this ).parents( '.form-step' ),
			    prevFormStep = thisFormStep.prev();

			scrollToFormTop( prevFormStep );
			//if the previous section isn't already open
			if ( prevFormStep.hasClass( 'closed' ) ) {

				//trigger click on previous section's toggle button
				prevFormStep.find( '.btn-section-toggle' ).trigger( 'click' );
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * @summary Next button in membership app
		 *
		 * Opens next section by triggering a click on expand/collapse btn
		 * Closes any other open sections
		 */
		function nextCollapsibleAppBtn() {
			var thisFormStep = $( this ).parents( '.form-step' ),
			    nextFormStep = thisFormStep.next();

			scrollToFormTop( nextFormStep );
			//if the next section isn't already open
			if ( nextFormStep.hasClass( 'closed' ) ) {
				//trigger click on next section's toggle button
				nextFormStep.find( '.btn-section-toggle' ).trigger( 'click' );
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * Scroll to step when prev/next buttons are clicked
		 *
		 * @param selector
		 */
		function scrollToFormTop( formStep ) {
			if ( formStep ) {
				$( 'html, body' ).animate( {
					                           scrollTop: ($( formStep )
						                                       .offset().top - 100
					                           )
				                           }, 500 );
			}
		}

		/**
		 * When submit button is clicked the first time, it will set global var false
		 * Used to detect if the form submission hasn't been attempted yet
		 */
		function detectDomDefault() {
			isdaFormFirstRender = false;
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * Re-validate form if fields have changed attrs
		 * @param $form
		 */
		function updateFormValidation( form ) {
			//submit validation on checkbox change
			form.validator( 'update' );

			let allFormGroups = form.find( '.form-group' ),
			    errorsPresent = true;

			if ( allFormGroups.hasClass( 'has-error' ) ) {
				errorsPresent = true;
			} else {
				errorsPresent = false;
			}

			//if no errors exist, check submit btn for disabled class
			if ( errorsPresent === false && isdaFormFirstRender === false ) {
				let submitBtn = form.find( '.btn-submit-adh-letter' );

				if ( submitBtn.hasClass( 'disabled' ) ) {
					form.validator( 'validate', { focus: false } );
				}
			}
		}

		/**
		 * @summary Add/remove attrs to conditional form groups
		 *
		 * If a form group has data attribute "data-conditional" matching the
		 * ID of the "root" checkbox that triggers it, this function fires.
		 *
		 * Add/removes required/disabled attributes on fields for JS validation
		 * @param checkbox
		 */
		function protocolCheckboxConditionalFields( checkbox ) {
			var thisCheckbox             = checkbox,
			    thisCheckboxId           = thisCheckbox.attr( 'id' ),
			    checkboxWrapper          = thisCheckbox.closest( '.checkbox' ),
			    thisCheckboxConditionals = checkboxWrapper.siblings( '[data-conditional="' + thisCheckboxId + '"]' ),
			    conditionalTextField     = thisCheckboxConditionals.children( 'input:text, input[type=email]' );

			if ( thisCheckboxConditionals !== null ) {
				if ( thisCheckbox.is( ':checked' ) ) {
					conditionalTextField.removeAttr( 'disabled', 'disabled' );
					conditionalTextField.attr( 'required', 'required' );
				} else {
					conditionalTextField.attr( 'disabled', 'disabled' );
					conditionalTextField.removeAttr( 'required', 'required' );
					//empty fields if box unchecked
					conditionalTextField.val( '' );
				}
			}
		}

		/**
		 * @summary Add/remove attrs to conditional sections

		 * If a div has data attribute "data-conditional-section" matching the
		 * ID of the root checkbox that triggers it, this function fires.
		 *
		 * Add/removes required/disabled attributes on fields for JS validation
		 * @todo: Update selectors in here after html changes
		 * @param checkbox
		 */
		function protocolCheckboxConditionalSections( checkbox ) {
			var thisCheckbox                    = checkbox,
			    thisCheckboxId                  = thisCheckbox.attr( 'id' ),
			    checkboxWrapper                 = thisCheckbox.closest( '.checkbox-enables-section' ),
			    checkboxWrapperSib              = checkboxWrapper.siblings( '.checkbox-enables-section' )
			                                                     .find( 'input:checkbox' ),
			    thisCheckboxConditionalSections = checkboxWrapper.parent()
			                                                     .siblings( '[data-conditional-section="' + thisCheckboxId + '"]' ),
			    sectionFields                   = thisCheckboxConditionalSections.find( 'input:checkbox' ),
			    sectionTextFields               = thisCheckboxConditionalSections.find( 'input:text' );

			if ( thisCheckboxConditionalSections !== null ) {
				if ( thisCheckbox.is( ':checked' ) ) {
					//require all fields in newly enabled section
					sectionFields.removeAttr( 'disabled', 'disabled' );
					sectionFields.attr( 'required', 'required' );

					//remove required on sibling checkbox since only 1 out of 2 "root" checkboxes should be checked
					checkboxWrapperSib.removeAttr( 'required', 'required' );
				} else {
					//disable all fields in disabled sections and clear them
					sectionFields.attr( 'disabled', 'disabled' );
					sectionFields.removeAttr( 'required', 'required' )
					             .removeAttr( 'checked' );
					if ( sectionTextFields !== null ) {
						sectionTextFields.attr( 'disabled', 'disabled' );
						sectionTextFields.removeAttr( 'required', 'required' )
						                 .val( '' );
					}

					//re-add required on sibling checkbox if neither of the 2 "root" checkboxes are checked
					checkboxWrapperSib.removeAttr( 'required', 'required' );
				}
			}
		}

		/**
		 * Show reference id area and require field (annex)
		 * @param select
		 */
		function enableReferenceID( select ) {
			var value          = select.attr( 'value' ),
			    selectGroupId  = select.attr( 'id' ),
			    refNumGroup    = $( '#' + selectGroupId ).parent()
			                                             .siblings( '[data-enable-ref-id="' + selectGroupId + '"]' ),
			    referenceField = refNumGroup.find( 'input:text' );

			if ( value === '0' || value === '' ) {
				$( refNumGroup ).removeClass( 'hidden' );
				$( referenceField ).attr( 'required', 'required' )
				                   .removeAttr( 'disabled', 'disabled' );
			} else {
				$( refNumGroup ).addClass( 'hidden' );
				$( referenceField ).attr( 'disabled', 'disabled' )
				                   .removeAttr( 'required', 'required' );
			}
		}

		/**
		 * @summary Only one checkbox required (Component F)
		 *
		 * Once checkbox in an area has been checked, remove
		 * required attr from other checkboxes in that area.
		 * So long as the checkbox doesn't have the required override,
		 * remove required attr.
		 *
		 * @todo: Get this working with data attribute, not a class
		 */
		function protocolOnlyOneRequiredCheckbox( checkbox ) {
			var thisCheckbox        = checkbox,
			    thisCheckboxWrapper = thisCheckbox.closest( '.checkbox' ),
			    checkboxSiblings    = thisCheckboxWrapper.siblings( '.checkbox' );
			//if this is a conditional section
			if ( thisCheckbox.parents()
			                 .hasClass( 'conditional-section' ) || thisCheckbox.parents()
			                                                                   .hasClass( 'form-group-require-one' ) ) {
				if ( thisCheckbox.is( ':checked' ) ) {
					//do not remove require attr if this is a required override checkbox
					checkboxSiblings.find( 'input:checkbox:not(.required-override)' )
					                .removeAttr( 'required', 'required' );
				} else {
					//should only add attribute if there are no other checkboxes checked
					if ( ! checkboxSiblings.find( 'input:checkbox' ).is( ':checked' )) {
						checkboxSiblings.find( 'input:checkbox' )
						                .attr( 'required', 'required' );
					}
				}
			}
		}

		function selectAllJurisdictionsToggle( checkbox ){
			let thisCheckbox          = checkbox,
			    thisCheckboxWrapper   = thisCheckbox.closest( '.checkbox' ),
			    thisCheckboxWrapperId = thisCheckboxWrapper.attr( 'id' ),
			    checkboxSiblings      = thisCheckboxWrapper.siblings( '.checkbox' ),
			    checkboxSiblingCheckboxes = checkboxSiblings.find( 'input:checkbox' );

			if ( thisCheckboxWrapperId !== 'select-all-jurisdictions' ) {
				return;
			}

			if ( thisCheckbox.is( ':checked' ) ) {
				checkboxSiblingCheckboxes.prop( 'checked', true );
			} else {
				checkboxSiblingCheckboxes.prop( 'checked', false );
			}
		}

		/**
		 * "D" template checkboxes disable each other
		 * "A" disables B & C checkboxes
		 * "C & D" disables the "A" checkbox
		 * @param checkbox
		 */
		function protocolToggleDisableCheckboxes( checkbox ) {
			var thisCheckbox      = checkbox,
			    checkboxWrapper   = thisCheckbox.closest( '.checkbox' ),
			    checkboxFormGroup = thisCheckbox.closest( '.form-group' ),
			    allCheckboxes     = checkboxFormGroup.find( 'input:checkbox' );

			//check if this is a conditional section for "D" template
			if ( checkboxFormGroup.hasClass( 'conditional-section' ) ) {
				if ( thisCheckbox.is( ':checked' ) ) {
					//check if this is checkbox A
					if ( checkboxWrapper.hasClass( 'checkbox-a' ) ) {
						checkboxFormGroup.find( '.checkbox-b input:checkbox, .checkbox-c input:checkbox' )
						                 .attr( 'disabled', 'disabled' )
						                 .removeAttr( 'checked' );
					}
					//Check if this is checkbox B or C
					if ( checkboxWrapper.hasClass( 'checkbox-b' ) || checkboxWrapper.hasClass( 'checkbox-c' ) ) {
						checkboxFormGroup.find( '.checkbox-a input:checkbox' )
						                 .attr( 'disabled', 'disabled' )
						                 .removeAttr( 'checked' );
					}
				} else {
					//remove disabled from formerly disabled checkboxes
					if ( checkboxWrapper.hasClass( 'checkbox-a' ) ) {
						checkboxFormGroup.find( '.checkbox-b input:checkbox, .checkbox-c input:checkbox' )
						                 .removeAttr( 'disabled', 'disabled' );
					}
					//remove disabled from formerly disabled checkboxes
					if ( checkboxWrapper.hasClass( 'checkbox-b' ) || checkboxWrapper.hasClass( 'checkbox-c' ) ) {
						var checkboxB = checkboxWrapper.find( '.checkbox-b input:checkbox' ),
						    checkboxC = checkboxWrapper.find( '.checkbox-c input:checkbox' );

						//@todo: Bug - need to keep "A" disabled if only either "B" or "C" is unchecked after both being checked
						//only enable A if both B & C are unchecked
						if ( checkboxB.prop( 'checked' ) !== false && checkboxC.prop( 'checked' ) !== false ) {
							checkboxFormGroup.find( '.checkbox-a input:checkbox' )
							                 .removeAttr( 'disabled', 'disabled' );
						}
					}
				}
			}
		}

		/**
		 * Requires a second checkbox get selected if targeted checkbox is checked (Method 1)
		 */
		function protocolRequiresSecondCheckbox( checkbox ) {
			let self              = checkbox,
			    checkboxWrap      = checkbox.closest( '.checkbox-requires-secondary' ),
			    siblingCheckboxes = checkboxWrap.siblings( '.checkbox' )
			                                    .find( 'input:checkbox' ),
			    sibsCheckedStatus = siblingCheckboxes.is( ':checked' );

			if ( self.is( ':checked' ) ) {
				self.addClass( 'required-override' );
				//only make other checkboxes required if none are already selected when Method 1 is checked
				if ( sibsCheckedStatus === false ) {
					self.attr( 'required', 'required' );
					siblingCheckboxes.attr( 'required', 'required' );
				}
			} else {
				self.removeClass( 'required-override' );
				//only keep other checkboxes required if none are already selected when Method 1 is unchecked
				if ( sibsCheckedStatus === true ) {
					self.removeAttr( 'required', 'required' );
					siblingCheckboxes.removeAttr( 'required', 'required' );
				}
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * @summary Add class for section errors
		 *
		 * Checks if the default was prevented due to the validator,
		 * and adds a class to the section containing errors.
		 */
		function revealSectionErrors( e ) {
			var form       = $( this ),
			    errorGroup = form.find( '.form-group.has-error' ),
			    errorStep  = errorGroup.closest( '.form-step' ),
			    formSteps  = form.find( '.form-step' );

			errorStep.addClass( 'section-has-error' );

			//check each step for errored groups
			formSteps.each( function() {
				var step = $( this ), groups = step.find( '.form-group' );

				if ( false === groups.hasClass( 'has-error' ) ) {
					step.removeClass( 'section-has-error' );
				}
			} );

		}

		/**
		 * Populates Point of Contact section when checkbox is checked
		 */
		function sameAsAbove() {
			$( '#point-of-contact-name' )
				.val( $( '#contact-fname' ).val() + ' ' + $( '#contact-lname' )
					.val() ).focus();
			$( '#point-of-contact-email' ).val( $( '#contact-email' ).val() )
			                              .focus();
			$( '#point-of-contact-phone' ).val( $( '#contact-phone' ).val() )
			                              .focus().blur();
		}

		/**
		 * Clears/resets form fields on click
		 * @param formSection
		 */
		function clearFormFields( formSection ) {
			var section     = $( formSection ),
			    fields      = section.find( ':input' ),
			    selectBoxes = section.find( 'select' );

			if ( fields !== null ) {
				fields.val( '' );
			}

			if ( selectBoxes !== null ) {
				selectBoxes.val( 'Select' );
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * Modular function to add repeatable field sets
		 * @param cloneId
		 * @param containerId
		 */
		function addFormGroup( cloneId, containerId ) {
			var wrapper                          = $( '#' + containerId ),
			    groups                           = wrapper.find( '.repeatable-form-group' ),
			    lastGroup = groups.last(),
			    clone = lastGroup.clone().attr( 'id', containerId + '-' + cloneId ).appendTo( wrapper );

			//if/else membership addt contacts
			if ( containerId === 'additional-contacts-wrapper' ) {
				//create clone and pass it to below func to update attrs
				updateRepeatableFieldAttrsContacts( wrapper, cloneId, clone );
			} else {
				//create clone and pass it to below func to update attrs
				updateRepeatableFieldAttrs( wrapper, cloneId, clone );
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * @summary Update ids/for attrs for cloned field sets
		 * @param wrapper
		 * @param cloneId
		 * @param clone
		 */
		function updateRepeatableFieldAttrs( wrapper, cloneId, clone ) {
			/**
			 * Note: Assume there are always only 2 text fields that get repeated with matching labels
			 * 1. save original's form group field ids and label attrs to use for clones
			 * 2. Find the first and second form groups in each clone
			 * 3. Find the text inputs and labels in each clone's form group
			 * 4. Update the ids/for attrs for clone text fields and labels using the original's
			 * as a base and appended with the cloneId increment.
			 */
			var origRepeatable    = wrapper.find( '.repeatable-form-group:first-of-type' ),
			    origFirstFieldId  = origRepeatable.find( '.form-group:nth-child(1) input' )
			                                      .attr( 'id' ),
			    origSecondFieldId = origRepeatable.find( '.form-group:nth-child(2) input' )
			                                      .attr( 'id' ), //find clone form groups
			    origThirdFieldId  = origRepeatable.find( '.form-group:nth-child(3) input' )
			                                      .attr( 'id' ), //find clone form groups
			    firstCloneGroup   = clone.find( '.form-group:nth-child(1)' ),
			    secondCloneGroup  = clone.find( '.form-group:nth-child(2)' ), //find remove btns from form groups
			    thirdCloneGroup   = clone.find( '.form-group:nth-child(3)' ), //find remove btns from form groups
			    cloneRemoveBtn    = clone.find( '.btn-remove-repeatable .sr-only' ), //find fields and labels in the 2 form groups for clones
			    firstCloneField   = firstCloneGroup.children( 'input' ),
			    firstCloneLabel   = firstCloneGroup.children( 'label' ),
			    firstCloneName    = incrementIndexInFieldArray( firstCloneField ),
			    secondCloneField  = secondCloneGroup.children( 'input' ),
			    secondCloneLabel  = secondCloneGroup.children( 'label' ),
			    secondCloneName   = incrementIndexInFieldArray( secondCloneField ),
			    thirdCloneField   = thirdCloneGroup.children( 'input' ),
			    thirdCloneLabel   = thirdCloneGroup.children( 'label' ),
			    thirdCloneName    = incrementIndexInFieldArray( thirdCloneField );

			//apply id and for attr to first field
			firstCloneField.attr( 'id', origFirstFieldId + '-' + cloneId )
			               .attr( 'name', firstCloneName ).val( '' );
			firstCloneLabel.attr( 'for', origFirstFieldId + '-' + cloneId );

			//apply id and for attr to second field
			secondCloneField.attr( 'id', origSecondFieldId + '-' + cloneId )
			                .attr( 'name', secondCloneName ).val( '' );
			secondCloneLabel.attr( 'for', origSecondFieldId + '-' + cloneId );

			//apply id and for attr to third field
			thirdCloneField.attr( 'id', origThirdFieldId + '-' + cloneId )
			               .attr( 'name', thirdCloneName ).val( '' );
			thirdCloneLabel.attr( 'for', origThirdFieldId + '-' + cloneId );

			//add id to screen reader text in remove buttons
			cloneRemoveBtn.find( '.sr-append' ).remove(); //clear existing appends
			$( '<span class="sr-append"> ' + cloneId + '</span>' )
				.appendTo( cloneRemoveBtn );
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * Does the same thing as the function above, except with more fields
		 * due to the additional contacts on membership
		 *
		 * @param wrapper
		 * @param cloneId
		 * @param clone
		 */
		function updateRepeatableFieldAttrsContacts( wrapper, cloneId, clone ) {
			//@todo: Refactor into a moer efficient function at some point but rn this works
			var original      = wrapper.children( '.single-contact:nth-child(1)' ),
			    region        = original.find( '.form-group:nth-of-type(1) .form-control' ),
			    prefix        = original.find( '.form-group:nth-of-type(2) .form-control' ),
			    fname         = original.find( '.form-group:nth-of-type(3) .form-control' ),
			    lname         = original.find( '.form-group:nth-of-type(4) .form-control' ),
			    suffix        = original.find( '.form-group:nth-of-type(5) .form-control' ),
			    title         = original.find( '.form-group:nth-of-type(6) .form-control' ),
			    email         = original.find( '.form-group:nth-of-type(7) .form-control' ),
			    phone         = original.find( '.form-group:nth-of-type(8) .form-control' ),
			    fax           = original.find( '.form-group:nth-of-type(9) .form-control' ),
			    address       = original.find( '.form-group:nth-of-type(10) .form-control' ),
			    city          = original.find( '.form-group:nth-of-type(11) .form-control' ),
			    country       = original.find( '.form-group:nth-of-type(12) .form-control' ),
			    state         = original.find( '.form-group:nth-of-type(13) .form-control' ),
			    zip           = original.find( '.form-group:nth-of-type(14) .form-control' ),
			    keyArray      = [
				    region, prefix, fname, lname, suffix, title, email, phone,
				    fax, address, city, country, state, zip
			    ],
			    regionClone   = clone.find( '.form-group:nth-of-type(1) .form-control' ),
			    prefixClone   = clone.find( '.form-group:nth-of-type(2) .form-control' ),
			    fnameClone    = clone.find( '.form-group:nth-of-type(3) .form-control' ),
			    lnameClone    = clone.find( '.form-group:nth-of-type(4) .form-control' ),
			    suffixClone   = clone.find( '.form-group:nth-of-type(5) .form-control' ),
			    titleClone    = clone.find( '.form-group:nth-of-type(6) .form-control' ),
			    emailClone    = clone.find( '.form-group:nth-of-type(7) .form-control' ),
			    phoneClone    = clone.find( '.form-group:nth-of-type(8) .form-control' ),
			    faxClone      = clone.find( '.form-group:nth-of-type(9) .form-control' ),
			    addressClone  = clone.find( '.form-group:nth-of-type(10) .form-control' ),
			    cityClone     = clone.find( '.form-group:nth-of-type(11) .form-control' ),
			    countryClone  = clone.find( '.form-group:nth-of-type(12) .form-control' ),
			    stateClone    = clone.find( '.form-group:nth-of-type(13) .form-control' ),
			    zipClone      = clone.find( '.form-group:nth-of-type(14) .form-control' ),
			    keyCloneArray = [
				    regionClone, prefixClone, fnameClone, lnameClone,
				    suffixClone, titleClone, emailClone, phoneClone, faxClone,
				    addressClone, cityClone, countryClone, stateClone, zipClone
			    ];

			$.each( keyCloneArray, function( index, value ) {
				var field            = $( this ),
				    existingNameAttr = incrementIndexInFieldArray( field ),
				    originalId       = keyArray[ index ].attr( 'id' ),
				    originalFor      = keyArray[ index ].siblings( '.control-label' )
				                                        .attr( 'for' );

				//empty clone fields
				field.val( '' );
				//add attributes/ids
				field.attr( 'id', originalId + '-' + cloneId );
				field.siblings( '.control-label' )
				     .attr( 'for', originalFor + '-' + cloneId );
				field.attr( 'name', existingNameAttr );
			} );
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * Increment "name" attrs for fields
		 * @param elem
		 */
		function incrementIndexInFieldArray( elem ) {
			if ( $( elem ).length && $( elem ).attr( 'name' ) ) {
				return $( elem ).attr( 'name' )
				                .replace( /\[(\d+)\]/, function( match, number ) {
					                // `number` refers to the first group (denoted with ())
					                return '[' + (+number + 1
					                ) + ']';
				                } );
			}

			return '';
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * Remove clone via trigger (close button) in the repeatable form group
		 * @param trigger
		 */
		function removeThisClone( trigger ) {
			var cloneWrapper = trigger.parents( '.repeatable-form-group' );

			cloneWrapper.find( 'input[required="required"]' )
			            .removeAttr( 'required', 'required' );

			updateFormValidation( $( '#protocols-adherence-letter-form' ) );

			cloneWrapper.remove();
		}
	}
)( jQuery );
